export namespace Permissions {
    /**
     * Permissions names
     */
    export enum Permission {
        /**
         * @deprecated Use `session_messages_send` instead
         */
        send_session_message = 'send_message',
        /**
         * @deprecated Use `template_messages_view` instead
         */
        view_template_messages = 'view_template_messages',
        /**
         * @deprecated Use `template_messages_send` instead
         */
        send_template_message = 'send_template_message',
        resolve_chat = 'resolve_chat',
        send_email = 'send_email',
        maintenance = 'maintenance',
        authenticate_users = 'authenticate_users',
        channels_view = 'channels_view',
        channels_manage = 'channels_manage',
        msg_provider_webhook = 'msg_provider_webhook',
        crm_webhook = 'crm_webhook',
        oauth_manage_own = 'oauth_manage_own',
        oauth_manage_default = 'oauth_manage_default',
        oauth_manage_all = 'oauth_manage_all',
        bots_view = 'bots_view',
        bots_edit = 'bots_edit',
        bots_delete = 'bots_delete',
        bots_history_delete = 'bots_history_delete',
        bot_session_summary_read = 'bot_session_summary_read',
        stats_read = 'stats_read',
        stats_settings_manage = 'stats_settings_manage',
        session_messages_send = 'session_messages_send',
        template_messages_send = 'template_messages_send',
        template_messages_view = 'template_messages_view',
        template_messages_manage = 'template_messages_manage',
        messages_bulk_send = 'messages_bulk_send',
        /**
         * View sensite messages as is
         */
        messages_sensitive_view = 'messages_sensitive_view',
        api_tokens_view = 'api_tokens_view',
        api_tokens_manage = 'api_tokens_manage',
        /**
         * Create new chats that previously not exists in system
         */
        chats_create = 'chats_create',
        /**
         * View all chats but not messages of this chats
         */
        chats_all_list = 'chats_all_list',
        /**
         * View all chats their messages
         */
        chats_all_view = 'chats_all_view',
        /**
         * Perform actions (resolve/assign/etc) on all chats
         */
        chats_all_manage = 'chats_all_manage',
        /**
         * View all chats of own department but not their messages
         */
        chats_own_department_list = 'chats_own_department_list',
        /**
         * View all chats of own department and their messages
         */
        chats_own_department_view = 'chats_own_department_view',
        /**
         * Perform actions (resolve/assign/etc) on all chats of own department
         */
        chats_own_department_manage = 'chats_own_department_manage',
        /**
         * View all chats that has no department but not their messages
         */
        chats_no_department_list = 'chats_no_department_list',
        /**
         * View all chats that has no department and their messages
         */
        chats_no_department_view = 'chats_no_department_view',
        /**
         * Perform actions (resolve/assign/etc) on all chats that has no department
         */
        chats_no_department_manage = 'chats_no_department_manage',
        /**
         * View all chats that have both no department and no agent set
         */
        chats_unbinded_list = 'chats_unbinded_list',
        /**
         * View all chats that have both no department and no agent set and their messages
         */
        chats_unbinded_view = 'chats_unbinded_view',
        /**
         * Perform actions (resolve/assign/etc) on all chats that have both no department and no agent set
         */
        chats_unbinded_manage = 'chats_unbinded_manage',
        /**
         * Perform actions (resolve/assign/etc) on chats that set to this user
         */
        chats_binded_manage = 'chats_binded_manage',
        /**
         * Send messages to assigned to this user chat
         */
        chats_assigned_send = 'chats_assigned_send',
        /**
         * Add notes to any chat
         */
        chats_all_notes_add = 'chats_all_notes_add',
        /**
         * View notes of any chat
         */
        chats_all_notes_view = 'chats_all_notes_view',
        /**
         * Add notes on chats that set to this user
         */
        chats_binded_notes_add = 'chats_binded_notes_add',
        /**
         * Add notes on chats that set to this user
         */
        chats_binded_notes_view = 'chats_binded_notes_view',
        /**
         * Remove chats notes added by any user
         */
        chats_notes_all_manage = 'chats_notes_all_manage',
        /**
         * Remove chats notes added by this user
         */
        chats_notes_own_manage = 'chats_notes_own_manage',
        /**
         * Resolve chats in bulk
         */
        chats_bulk_resolve = 'chats_bulk_resolve',
        departments_view = 'departments_view',
        departments_manage = 'departments_manage',
        /**
         * View all files that is not messages attachments (access for those governed by access to chat them from),
         * and not owned by this user (for thos user always have access)
         */
        files_all_view = 'files_all_view',
        /**
         * Manage all files that is not messages attachments (access for those governed by access to chat them from),
         * and not owne by this user (for thos user always have access)
         */
        files_all_manage = 'files_all_manage',
        /**
         * View files not owned by anyone and not attached to chat
         */
        files_unowned_view = 'files_unowned_view',
        /**
         * Manage files not owned by anyone and not attached to chat
         */
        files_unowned_manage = 'files_unowned_manage',
        /**
         * Upload new files
         */
        files_add = 'files_add',
        files_allow_download_not_scanned = 'files_allow_download_not_scanned',
        files_allow_download_infected = 'files_allow_download_infected',
        quick_replies_view = 'quick_replies_view',
        quick_replies_manage = 'quick_replies_manage',
        schedule_tasks_list = 'schedule_tasks_list',
        schedule_tasks_manage = 'schedule_tasks_manage',
        users_view = 'users_view',
        users_manage = 'users_manage',
        users_status_view = 'users_status_view',
        users_manage_auth_credentials = 'users_manage_auth_credentials',
        users_create_auth_tokens = 'users_create_auth_tokens',
        export_create = 'export_create',
        export_list = 'export_list',
        export_download = 'export_download',
        export_delete = 'export_delete',
        person_get = 'person_get',
        person_chat_link = 'person_chat_link',
        person_chat_unlink = 'person_chat_unlink',
        metrics_view = 'metrics_view',
    }
    /**
     * Permissions groups
     */
    export enum Group {
        templates = 'templates',
        crm = 'crm',
        messaging = 'messaging',
        auth = 'auth',
        users = 'users',
        misc = 'misc',
        channels = 'channels',
        chats = 'chats',
    }
    /**
     * Permissions information
     */
    export const Info = {
        [Permission.view_template_messages]: {
            title: 'View template messages',
            group: Group.templates,
        },
        [Permission.send_template_message]: {
            title: 'Send template messages',
            group: Group.templates,
        },
        [Permission.resolve_chat]: {
            title: 'Resolve chat',
            group: Group.crm,
        },
        [Permission.msg_provider_webhook]: {
            title: 'Call messaging provider webhook',
            group: Group.messaging,
        },
        [Permission.crm_webhook]: {
            title: 'Call CRM webhook',
            group: Group.crm,
        },
        [Permission.send_email]: {
            title: 'Send Email',
            group: Group.crm,
        },
        [Permission.authenticate_users]: {
            title: 'Create authentication custom token',
            group: Group.auth,
        },
        [Permission.users_manage]: {
            title: 'Manage users',
            group: Group.users,
        },
        [Permission.maintenance]: {
            title: 'Maintenance',
            group: Group.misc,
        },
        [Permission.channels_view]: {
            title: 'List channels',
            group: Group.channels,
        },
        [Permission.channels_manage]: {
            title: 'Manage channels',
            group: Group.channels,
        },
        [Permission.send_session_message]: {
            title: 'Send session message',
            group: Group.messaging,
        },
        [Permission.chats_all_list]: {
            title: 'List all chats',
            group: Group.chats,
        },
        [Permission.chats_all_manage]: {
            title: 'Manage all chats',
            group: Group.chats,
        },
        [Permission.chats_all_view]: {
            title: 'View all chats',
            group: Group.chats,
        },
    };
}
